
export default '<!DOCTYPE html>'+
'<html>'+
'<head>'+
'<meta charset="UTF-8">'+
'<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">'+
'<title></title>'+
'<style type="text/css">'+
'  html {'+
'    height: 100%;'+
'  }'+
'  body {'+
'    -moz-box-sizing: border-box;'+
'    -webkit-box-sizing: border-box;'+
'    box-sizing: border-box;'+
'    padding: 0px;'+
'    margin: 0px;'+
'    background: transparent;'+
'    cursor: text;'+
'    font-size: 14px;'+
'    font-family: Lato,"Helvetica Neue",Arial,Helvetica,sans-serif;'+
'    color: rgba(0, 0, 0, 0.8);'+
'    line-height: 1.33;'+
'    height: 100%;'+
'  }'+
''+
'  img[src*=emojione] {'+
'    width: 20px;'+
'    height: 20px;'+
'  }'+
''+
'  ul {'+
'    margin: 0;'+
'    padding-left: 25px;'+
'  }'+
'  ol {'+
'    margin: 0;'+
'    padding-left: 1.5em;'+
'    text-indent: -1.5em;'+
'    list-style-position: inside;'+
'  }'+
''+
'  p {'+
'    margin: 0;'+
'  }'+
''+
'  a {'+
'    text-decoration: underline;'+
'    color: #00b2f3;'+
'    word-break: break-all;'+
'  }'+
''+
'  a:hover {'+
'    color: #009fda;'+
'  }'+
'</style>'+
'</head>'+
'<body>'+
'</body>'+
'</html>'



// WEBPACK FOOTER //
// ./src/web/components/rich-text-editor-iframe-html.js